import type { LibraryItem } from '../../api/types';
import MediaCard from './MediaCard';
import Shelf from './Shelf';

/// One row of a home screen. Nothing is rendered when there is nothing in it - an empty row is
/// worse than no row. Every tile in it is the size and shape of a film poster, episodes
/// included, so films and episodes line up.
export default function MediaRow({ title, items }: { title: string; items: LibraryItem[] }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Shelf title={title} columnWidth={190}>
      {items.map((item) => (
        <MediaCard key={item.id} item={item} asProgramme />
      ))}
    </Shelf>
  );
}
